<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h2 id="prep-file-heading">Modifier un Lecteur</h2>
    </div>

    <div class="modal-body">
      <div class="modal-body">
        <form class="col-10" name="readerUpdateForm" role="form" (ngSubmit)="f.form.valid && onSubmit()"
          #f="ngForm" [formGroup]="readerUpdateForm">
          <div class="form-group row">
            <label class="form-control-label" for="field_label"
              >Label</label>
              <input type="text" class="form-control" id="field_label" name="label"
                    [ngClass]="{ 'is-invalid': f.submitted && readerUpdateForm?.controls?.label?.errors }"
                     formControlName="label" />
                    <div *ngIf="f.submitted && readerUpdateForm?.controls?.label?.errors " class="text-danger"> champ
                        obligatoire
                    </div>
          </div>

          <!-- <div class="form-group row">
            <label class="form-control-label" for="field_desc">Description</label>
            <input type="text" class="form-control" id="field_desc" name="name"
                    [ngClass]="{ 'is-invalid': f.submitted && readerUpdateForm?.controls?.desc?.errors }"
                     formControlName="desc" />
                    <div *ngIf="f.submitted && readerUpdateForm?.controls?.desc?.errors " class="text-danger"> champ
                      obligatoire
                  </div>
          </div> -->
          <div class="form-group row align-items-center">
            <div class="custom-control custom-switch">
             <input type="checkbox" class="custom-control-input" id="switch1" formControlName="active">
             <label class="custom-control-label" for="switch1" >Actif</label>
           </div>
         </div>
          <div class="m-2">
            <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal" (click)="close();">
              &nbsp;<span>Annuler</span>
            </button>

            &nbsp;&nbsp;
            <button type="submit" id="save-entity" class="btn btn-primary button titre">
              &nbsp;<span>Valider</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
